module.exports = __webpack_public_path__ + "img/userApproval.45c3a232.png";